import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { Checkboxes } from "../../../FlowConfigurationInputs";

export default function NewFolder({
  action,
  variables,
  setOpenVariable,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FOLDER.";
  // checkbox options 
  const options = {
    checkboxes: { label: label + "OVERWRITE" },
  };
  return (
    <div>
      <div className="form-element">
        {t(label + "FOLDER")}
        <TextInput
          action={action}
          inputName="folderPath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired
          extractPath="folder"
          fieldType="string"
          displayName={t(label + 'FOLDER')}
        />
      </div>
      <div className="form-element">
        <Checkboxes
          action={action}
          inputName="overwriteFolder"
          options={options.checkboxes}
        />
      </div>
    </div>
  );
}
